import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

import { ForgotPasswordForm } from "@/components/auth/forgot-password-form"
import { FRONTEND_ROUTES } from "@/constants"
import { useAuth } from "@/contexts/auth"
export function ForgotPasswordPage() {
  const navigate = useNavigate()
  const { authData } = useAuth()

  useEffect(() => {
    if (authData?.accessToken) {
      navigate(FRONTEND_ROUTES.DASHBOARD.href, {
        replace: true,
      })
    }
  }, [authData, navigate])

  return <ForgotPasswordForm />
}
